import { LineChart as ReLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"

const LineChart = ({ height = 300, width = "100%", data, showDoubleLine = false, strokeColor = "#533A71", stroke2Color = '#82ca9d', showYAxis = true, dataKey1 = 'pv', dataKey2 = 'uv' }) => {
  return (
    <ResponsiveContainer width={width} height={height}>
      <ReLineChart data={data} margin={{ top: 5, right: 0, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="name" />
        {showYAxis && <YAxis />}
        <Tooltip />
        <Line type="monotone" dataKey={dataKey1} stroke={strokeColor} />
        {showDoubleLine && <Line type="monotone" dataKey={dataKey2} stroke={stroke2Color} />}
      </ReLineChart>
    </ResponsiveContainer>
  )
}

export default LineChart
